module.exports = __webpack_public_path__ + "static/img/103053.20b29cd7.png";